import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Illustration.st.css';
import { dataHooks } from '../../constants';
import { useBaseModalLayoutContext } from '../../BaseModalLayoutContext';
export var Illustration = function Illustration(_ref) {
  var dataHook = _ref.dataHook,
      className = _ref.className,
      children = _ref.children;

  var _useBaseModalLayoutCo = useBaseModalLayoutContext(),
      illustrationClassName = _useBaseModalLayoutCo.illustrationClassName,
      _useBaseModalLayoutCo2 = _useBaseModalLayoutCo.illustration,
      illustration = _useBaseModalLayoutCo2 === void 0 ? children : _useBaseModalLayoutCo2;

  className = classNames(illustrationClassName, className);
  return illustration && /*#__PURE__*/React.createElement("div", _extends({
    "data-hook": dataHook
  }, styles('root', {}, {
    className: className
  })), typeof illustration === 'string' ? /*#__PURE__*/React.createElement("img", {
    className: styles.image,
    src: illustration,
    "data-hook": dataHooks.illustrationSrc
  }) : illustration) || null;
};
Illustration.propTypes = {
  /** additional css classes */
  className: PropTypes.string,

  /** data hook for testing */
  dataHook: PropTypes.string,

  /** The illustration src or the illustration node itself */
  illustration: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
Illustration.defaultProps = {};